import React from 'react'

import { Typography } from '~/components/elements/Typography'

export type PartnerCellProps = {
  dataItem: {
    partnerSeat: { total: number; used: number }
  }
}

export const PartnerCell = ({ dataItem }: PartnerCellProps) => {
  const { partnerSeat } = dataItem

  return (
    <td>
      <Typography fontSize={14} variant="normal">
        {`${partnerSeat.used} / ${partnerSeat.total}`}
      </Typography>
    </td>
  )
}
